module.exports = "/images/vendor/flag-icon-css/flags/4x3/cl.svg?8949f9e6d4f88c4f5bc1fe5f3b4e44c4";